import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class RotaVisitaValidation extends DefaultValidation {

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let valid = true;
        let abaGeral = refs.abaGeral.$refs;

        if (!model.descricao) {
            abaGeral.descricaoInput.focusedOut = true;
            console.error("Validação de ROTA falhou no campo DESCRICAO.");
            this.showMessage(new Message('alert', 'msg-obrigatorio-descricao', true));
            valid = false;
        }

        if (!model.usuario) {
            abaGeral.colaboradorSelect.focusedOut = true;
            console.error("Validação de ROTA falhou no campo USUARIO.");
            this.showMessage(new Message('alert', 'msg-obrigatorio-colaborador', true));
            valid = false;
        }

        if (model.tipoFrequencia == 2 && !model.frequencia) {
            abaGeral.diaSemanaSelect.focusedOut = true;
            console.error("Validação de ROTA falhou no campo FREQUENCIA.");
            this.showMessage(new Message('alert', 'msg-selecione-um-dia-da-semana', true));
            valid = false;
        }

        // if (model.idrotavisita) {
        //     let abaCliente = refs.abaCliente.$refs;
        // }

        return valid;
    }

}